<script setup lang="ts">
import { projectConcepts } from '../../data/siteContent'

function markArtworkUnavailable(event: Event) {
  const image = event.currentTarget
  if (image instanceof HTMLImageElement) image.classList.add('is-error')
}
</script>

<template>
  <section id="projects" class="section projects-section" aria-labelledby="projects-title">
    <div class="section-frame">
      <div class="section-heading" data-reveal>
        <p class="section-kicker">04 / PROJECTS AWAKEN</p>
        <h2 id="projects-title">项目觉醒</h2>
        <p>今天还只是一个光点。未来，它可能成为你亲手交付的真实作品。</p>
        <small class="projects-section__note"
          >以下为项目方向示意，展示软件工程学习中可能完成的作品类型。</small
        >
      </div>

      <div class="project-observatory">
        <article
          v-for="(project, index) in projectConcepts"
          :key="project.name"
          class="project-signal"
          :class="`project-signal--${project.pattern}`"
          :style="{
            '--index': index,
            '--project-accent': project.accent,
            '--project-image-position': project.imagePosition,
            '--project-image-scale': project.imageScale,
          }"
          data-reveal
        >
          <div class="project-signal__depth" data-pointer-depth="tilt">
            <div class="project-signal__visual">
              <img
                class="project-signal__image"
                :src="project.image"
                :alt="project.imageAlt"
                width="1280"
                height="720"
                loading="lazy"
                decoding="async"
                @error="markArtworkUnavailable"
              />
              <div class="project-signal__fallback" aria-hidden="true">
                <span>VISUAL SIGNAL UNAVAILABLE</span>
                <i />
              </div>
              <div class="project-signal__veil" aria-hidden="true" />
              <div
                class="project-signal__motion"
                :class="`project-signal__motion--${project.motion}`"
                aria-hidden="true"
              >
                <i v-for="signal in 4" :key="signal" :style="{ '--signal': signal }" />
              </div>
              <div class="project-signal__meta" aria-hidden="true">
                <span>CONCEPT_{{ String(index + 1).padStart(2, '0') }}</span>
                <span>PROJECT TYPE</span>
              </div>
            </div>
            <div class="project-signal__copy">
              <p>{{ project.type }} <em>方向示意</em></p>
              <h3>{{ project.name }}</h3>
              <span>{{ project.description }}</span>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>
